import React from 'react'
import PropTypes from 'prop-types'
import Popup from '@aytm/lib/rfd-ui/components/basic/popup'
import { imageAsset as imageAssetUrl } from '@aytm/app/survey/editor/resources/urls'
import {
  IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT,
  IMAGE_ASSET_PATH_FILTER_RESIZE_AND_PAD
} from '@aytm/lib/common/assets'
import {
  ALLOWED_HTML_TAGS,
  PIPING_MASK_REGEX,
  QUESTION_TITLE_PIPING_THUMB_HEIGHT,
  QUESTION_TITLE_PIPING_THUMB_WIDTH,
  QUESTION_TITLE_PIPING_IMAGE_MIN_WIDTH,
  QUESTION_TITLE_PIPING_IMAGE_MAX_WIDTH,
  QUESTION_TITLE_PIPING_IMAGE_MIN_HEIGHT,
  QUESTION_TITLE_PIPING_IMAGE_MAX_HEIGHT
} from '@aytm/app/stats/page/comments/lib/constants'
import { removeLogicFromText } from '@aytm/app/stats/page/comments/lib/utils'
import style from '@aytm/app/stats/page/comments/comments/styles/OEQuestionTitle.module.scss'
import ImagePreview from '@aytm/app/survey/editor/components/content/assets/ImagePreview'

const OEQuestionTitle = ({ pipingMask, questionText, nodeOptions, imagesData }) => {
  let resultText = (pipingMask && pipingMask[`___${nodeOptions.value}t`]) || questionText
  let thumbPreview = null

  const renderQuestionThumbnail = image => (
    <div className={style['comment-header-question-title-thumbnail']}>
      <Popup
        className={style['comment-header-question-title-thumbnail-popup']}
        trigger="hover"
        direction="left"
        portal
        hideOtherPopupsOnShow
        content={() => (
          <ImagePreview
            minWidth={`${QUESTION_TITLE_PIPING_IMAGE_MIN_WIDTH}px`}
            maxWidth={`${QUESTION_TITLE_PIPING_IMAGE_MAX_WIDTH}px`}
            minHeight={`${QUESTION_TITLE_PIPING_IMAGE_MIN_HEIGHT}px`}
            maxHeight={`${QUESTION_TITLE_PIPING_IMAGE_MAX_HEIGHT}px`}
            imageUrl={image.original_url}
            previewUrl={imageAssetUrl(image.original_path, {
              width: QUESTION_TITLE_PIPING_IMAGE_MAX_WIDTH,
              height: QUESTION_TITLE_PIPING_IMAGE_MAX_HEIGHT,
              filter: IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT,
              unsharp: true,
              backgroundColor: 'transparent'
            })}
          />
        )}
        contentTheme="thin-black"
      >
        <img
          src={imageAssetUrl(image.original_path, {
            width: QUESTION_TITLE_PIPING_THUMB_WIDTH,
            height: QUESTION_TITLE_PIPING_THUMB_HEIGHT,
            filter: IMAGE_ASSET_PATH_FILTER_RESIZE_AND_PAD,
            unsharp: true,
            backgroundColor: 'white'
          })}
        />
      </Popup>
    </div>
  )

  if (nodeOptions.image) {
    if ('string' == typeof nodeOptions.image) {
      if (imagesData[nodeOptions.image]) {
        thumbPreview = renderQuestionThumbnail({
          original_url: imagesData[nodeOptions.image].original.url,
          original_path: imagesData[nodeOptions.image].original.path
        })
      }
    } else {
      thumbPreview = renderQuestionThumbnail({
        original_url: nodeOptions.image.original.url,
        original_path: nodeOptions.image.original.path
      })
    }
  }

  if ('string' == typeof resultText) {
    resultText.match(PIPING_MASK_REGEX)?.forEach(matchedItem => {
      const key = matchedItem.match(/\[(.*)]/i)[1].toLowerCase()
      const mask = key && pipingMask ? pipingMask[key.toLowerCase()] : null
      if (mask) {
        if (mask.original_url) {
          resultText = resultText.replace(matchedItem, '')
          thumbPreview = renderQuestionThumbnail(mask)
        } else {
          resultText = resultText.replace(matchedItem, mask)
        }
      }
    })

    resultText = removeLogicFromText(resultText)
    if (ALLOWED_HTML_TAGS.test(resultText)) {
      resultText = <span dangerouslySetInnerHTML={{ __html: resultText }} />
    }
  }

  return (
    <>
      {thumbPreview}
      <strong className={style['comment-header-question-title-name']}>{nodeOptions.prefix}: </strong>
      {resultText}
    </>
  )
}

OEQuestionTitle.propTypes = {
  pipingMask: PropTypes.object,
  questionText: PropTypes.string,
  nodeOptions: PropTypes.object,
  imagesData: PropTypes.object
}

OEQuestionTitle.displayName = 'QuestionTitle'

export default OEQuestionTitle
